<template>
  <div class="col-sm-12 nopads">
    <div class="search-form px-2">
      <div class="col-sm-12 search-form-title">
        <font-awesome-icon icon="search" />
        {{ $t('common.search') }}
      </div>
      <form
        @submit.prevent="onSubmit"
        @reset="onReset"
      >
        <div class="row nopads">
          <div class="col-sm-4">
            <span class="search-title">{{ $t('contracts.contract_collection.title') }}</span>
            <select
              v-model="contractCollection"
              class="form-select form-select-sm"
            >
              <option :value="null">
                {{ $t('contracts.select_contract_collection') }}
              </option>
              <option
                v-for="option in contractCollectionOptions"
                :key="option.id"
                :value="option.id"
              >
                {{ option.name }}
              </option>
            </select>
          </div>
          <div class="col-sm-4">
            <span class="search-title">{{ $t('contracts.customer') }}</span>
            <select
              v-model="customer"
              class="form-select form-select-sm"
            >
              <option :value="-1">
                {{ $t('contracts.select_customer') }}
              </option>
              <option
                v-for="option in customerOptions"
                :key="option.id"
                :value="option.id"
              >
                {{ option.name }}
              </option>
            </select>
          </div>
          <div class="col-sm-4">
            <span class="search-title">{{ $t('orders.contractor') }}</span>
            <select
              v-model="contractor"
              class="form-select form-select-sm"
            >
              <option :value="-1">
                {{ $t('orders.select_contractor') }}
              </option>
              <option
                v-for="option in contractors"
                :key="option.id"
                :value="option.id"
              >
                {{ option.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="row nopads">
          <div class="col-sm-4">
            <span class="search-title">{{ $t('orders.executor') }}</span>
            <select
              v-model="executor"
              class="form-select form-select-sm"
              :disabled="!executors || executors.length < 1"
            >
              <option :value="null">
                {{ $t('orders.select_executor') }}
              </option>
              <option
                v-for="option in executors"
                :key="option.id"
                :value="option.id"
              >
                {{ option.name }}
              </option>
            </select>
          </div>
          <div class="col-sm-4">
            <span class="search-title">{{ $t('contracts.name') }}</span>
            <input
                v-model="contractName"
                class="form-control form-control-sm"
                type="text"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4">
            <span class="search-title">{{ $t('contracts.number') }}</span>
            <input
              v-model="contractNumber"
              class="form-control form-control-sm"
              type="text"
            >
          </div>
          <div class="col-sm-4">
            <span class="search-title">{{ $t('contracts.worksite_key') }}</span>
            <input
              v-model="workSiteKey"
              class="form-control form-control-sm"
              type="text"
            >
          </div>
          <div class="col-sm-2">
            <span class="search-title">{{ $t('contracts.status') }}</span>
              <div class="form-check form-check-md">
                  <input
                      class="form-check-input"
                      type="checkbox"
                      id="selectAllContracts"
                      v-model="open"
                  />
                  <label class="form-check-label own-check" for="selectAllContracts">
                      {{ $t('contracts.only_open') }}
                  </label>
              </div>
          </div>
          <div class="col-sm-2 mt-4">
              <div class="form-check form-check-md">
                  <input
                      id="selectAllContracts"
                      v-model="onlyUserOwnedContracts"
                      class="form-check-input"
                      type="checkbox"
                  >
                  <label class="form-check-label own-check" for="selectAllContracts">
                      {{ $t('contracts.only_user_owned_contracts') }}
                  </label>
              </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4">
            <span class="search-title">{{ $t('contracts.start') }} - {{
              $t('trip_list.road_sec_from')
            }}</span>
            <input
              v-model="fromDate"
              class="form-control form-control-sm"
              type="date"
            >
          </div>
          <div class="col-sm-4">
            <span class="search-title">{{ $t('contracts.start') }} - {{
              $t('trip_list.road_sec_to')
            }}</span>
            <input
              v-model="toDate"
              class="form-control form-control-sm"
              type="date"
            />
          </div>
          <div class="col-sm-4">
            <span class="search-title">{{ $t('contracts.user_owned') }}</span>
            <select
              v-model="selectedUser"
              class="form-select form-select-sm"
            >
              <option :value="null">
                {{ $t('contracts.select_user') }}
              </option>
              <option
                v-for="option in users"
                :key="option.id"
                :value="option.id"
              >
                  {{ option.last_name + ', ' + option.first_name }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-sm-12 d-flex justify-content-end my-2">
            <button type="reset" class="btn btn-danger form-button">
                {{ $t('ins_report.clear') }}
            </button>
            <button type="submit" class="btn btn-primary form-button">
                {{ $t('ins_report.search') }}
            </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {timeUtils} from '../mixins/TimeUtils'

export default {
    name: 'ContractSearch',
    mixins: [restApi, timeUtils],
    data: function () {
        return {
            loading: false,
            customerOptions: null,
            contractors: [],
            contractCollectionOptions: [],
            users: [],
            selectedUser: null,
            contractName: null,
            contractCollection: null,
            customer: -1,
            contractor: -1,
            open: true,
            contractNumber: null,
            workSiteKey: null,
            fromDate: null,
            toDate: null,
            onlyUserOwnedContracts: false,
            executor: null,
            executors: []
        }
    },
    mounted: function () {
        this.fetchContractCollections()
        this.fetchCustomers()
        this.fetchContractors()
        this.fetchUsers()
        this.fetchExecutors()
    },
    methods: {
        fetchCustomers: function () {
            this.loading++
            this.restFetch(this.customerUrl, this.handleCustomers)
        },
        handleCustomers: function (response) {
            this.loading--
            this.customerOptions = response.data
        },
        fetchUsers: function () {
            this.loading = true
            this.restFetch(this.userUrl, this.handleUsers)
        },
        handleUsers: function (response) {
            this.users = response.data
            this.loading = false
        },
        fetchContractors: function () {
            this.contractors = []
            this.loading++
            let params = {}
            if (this.company && this.company > 0) {
                params.company = this.company
            }
            this.restFetchParams(this.contractorUrl, params, this.handleContractors)
        },

        handleContractors: function (response) {
            this.loading--
            if (response && response.data) {
                this.contractors = response.data
            }
        },
        fetchExecutors: function () {
            this.executors = []
            this.loading++
            let params = {}
            if (this.company && this.company > 0) {
                params.company = this.company
            }
            this.restFetchParams(this.executorUrl, params, this.handleExecutors)
        },
        handleExecutors: function (response) {
            this.loading--
            if (response && response.data) {
                this.executors = response.data
            }
        },
        fetchContractCollections: function () {
            this.loading++
            this.restFetch(this.contractCollectionSearchUrl, this.handleContractCollections)
        },
        handleContractCollections: function (response) {
            this.loading--
            this.contractCollectionOptions = response && response.data ? response.data : []
        },
        onSubmit: function () {
            var params = {}
            if (this.customer > 0) {
                params.customer = this.customer
            }
            if(this.contractCollection != null) {
                params.contract_collection = this.contractCollection
            }
            if (this.contractor > 0) {
                params.contractor = this.contractor
            }
            if (this.contractName != null && this.contractName.trim()) {
                params.name = this.contractName
            }
            if (this.contractNumber != null && this.contractNumber.trim()) {
                params.number = this.contractNumber
            }
            if (this.workSiteKey != null && this.workSiteKey.trim()) {
                params.work_site_key = this.workSiteKey
            }
            if (this.fromDate !== null && this.fromDate.trim()) {
                params.startDate = this.localTimeToUtcTime(this.fromDate).getTime()
            }
            if (this.toDate !== null && this.toDate.trim()) {
                params.endDate = this.getEndOfTheDay(this.toDate).getTime()
            }
            if (this.open) {
                params.open = 1
            }
            if (this.onlyUserOwnedContracts) {
                params.onlyUserOwnedContracts = 1
            }
            if(this.selectedUser !== null) {
                params.selected_user = this.selectedUser
            }
            if (this.executor !== null) {
                params.executor = this.executor
            }
            this.$emit('search', params)
        },

        onReset: function () {
            this.contractName = null
            this.contractCollection = null
            this.customer = -1
            this.contractor = -1
            this.contractNumber = null
            this.workSiteKey = null
            this.fromDate = null
            this.toDate = null
            this.executor = null
        }
    }
}
</script>

<style scoped>
.search-form select {
    text-overflow: ellipsis;
}
</style>
